import { z } from 'zod';

export const modelFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Nome do modelo é obrigatório')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  isActive: z.boolean().optional().default(true),
});

export type ModelFormData = z.infer<typeof modelFormSchema>;

export const versionFormSchema = z.object({
  name: z
    .string()
    .min(1, 'Nome da versão é obrigatório')
    .max(100, 'Nome deve ter no máximo 100 caracteres'),
  modelId: z.string().uuid('Modelo é obrigatório'),
  isActive: z.boolean().optional().default(true),
});

export type VersionFormData = z.infer<typeof versionFormSchema>;
